import axios from "axios";
import {
    URLAPI,
    BONUS_PATH,
    BONUS_ITEM_PATH,
    BONUS_CREATE_PATH,
    BONUS_UPDATE_PATH,
    BONUS_IMPORT_PATH,
    BONUS_EXPORT_FILE_PATH,
} from "../config";
import {LOGOUT} from './users'

const init = {
    _get_all_bonus: {
        data: [],
        status: 0,
        message: {},
    },
    _create_bonus: {
        data: {},
        status: 0,
        message: {},
    },
    _update_bonus: {
        data: {},
        status: 0,
        message: {},
    },
    _import_bonus: {
        data: {},
        status: 0,
        message: {},
    },
}

const GET_ALL_BONUSS = "GET_ALL_BONUSS";
export const CREATE_BONUS = "CREATE_BONUS";
export const UPDATE_BONUS = "UPDATE_BONUS";
export const IMPORT_BONUS = "IMPORT_BONUS";


export const bonus_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_BONUSS:
            return {
                ...state,
                _get_all_bonus: action.payload,
            };
        case CREATE_BONUS:
            return {
                ...state,
                _create_bonus: action.payload,
            };
        case UPDATE_BONUS:
            return {
                ...state,
                _update_bonus: action.payload,
            };
        case IMPORT_BONUS:
            return {
                ...state,
                _import_bonus: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}


export const get_all_bonus = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${BONUS_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_BONUSS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_BONUSS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_BONUSS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al obtener los registros",
                },
            });
        }
    }
}


export const create_bonus = (token, data) => async (dispatch) => {
    try {

        const response = await axios.post(`${URLAPI}${BONUS_CREATE_PATH}`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: CREATE_BONUS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: CREATE_BONUS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_BONUS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al crear el registro",
                },
            });
        }
    }
}


export const update_bonus = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${BONUS_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_BONUS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: UPDATE_BONUS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_BONUS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const searchItemGroup = async (token, id) => {
    return await axios.get(`${URLAPI}${BONUS_ITEM_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
}

export const importBonus = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${BONUS_IMPORT_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: IMPORT_BONUS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: IMPORT_BONUS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: IMPORT_BONUS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const export_file = async (token, data) => {
     return await axios.post(`${URLAPI}${BONUS_EXPORT_FILE_PATH}`, data, {
         responseType: 'blob',
         headers: {Authorization: `Token ${token}`,},
    });
}


export const clear_bonus = (type) => async dispatch => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}